<template>
  <div class="plugin-wrap detail_title_desc" v-if="config">
    <div class="ms-row center-xs">
      <!-- <div class="col-xs-12 col-sm-8 col-md-6 col-lg-6"> -->
      <div class="col-xs-12 col-sm-8 col-md-8">
        <h2 class="heading-h2 m-product-details__ingredients-title">{{config.title}}</h2>
        <div class="m-product-details__ingredients-subtitle">
          <div class="content-asset">
            <p class="text--no-margin">{{config.desc}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductDetailTitleDesc",
  props: {
    config: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
  .detail_title_desc {
    padding: 2.1875rem 1.0625rem 2.5rem; text-align: center;
  }
  .m-product-details__ingredients-title { font-size: 1.5625rem; margin: 0 0 .9375rem; }

  @media screen and (min-width: 48em) {
    .detail_title_desc {
      // margin: 2.1875rem 0 7.5rem; 
      margin: 2.8125rem 0; padding: 0;
    }
    .m-product-details__ingredients-title { padding: 0 0 0 .9375rem; }
    .m-product-details__ingredients-subtitle { padding: 0 4.6875rem 0 .9375rem; }
  }
  @media screen and (min-width: 64em) {
    .detail_title_desc {
      // margin: 2.1875rem 0 10rem;
      margin: 2.8125rem 0;
    }
    .m-product-details__ingredients-title { padding: 0; }
    .m-product-details__ingredients-subtitle { padding: 0 4.375rem 0 0; }
  }
  @media screen and (min-width: 75em) {
    .detail_title_desc {
      // margin: 2.8125rem 0 10.625rem;
      margin: 2.8125rem 0;
      &:before { display: block; content: " "; margin-top: -4.375rem; height: 4.375rem; visibility: hidden; pointer-events: none; }
    }
    .m-product-details__ingredients-subtitle { padding: 0 6.25rem; }
  }
</style>